/** Set when user starts embedded signup (`/auth/signup`); cleared in `redirect()`. */
export const AUTH_EMBEDDED_RETURN_KEY = 'auth_embedded_return';

export function setAuthEmbeddedReturn() {
  sessionStorage.setItem(AUTH_EMBEDDED_RETURN_KEY, '1');
}

export function peekAuthEmbeddedReturn() {
  return sessionStorage.getItem(AUTH_EMBEDDED_RETURN_KEY) === '1';
}

export function clearAuthEmbeddedReturn() {
  sessionStorage.removeItem(AUTH_EMBEDDED_RETURN_KEY);
}
